import { useState, useEffect } from 'react';
import { BraveBupAPI } from '@BUP/services/Axios';
import { useAuth } from '@BUP/hooks';

export function useResources() {
  const { user } = useAuth();
  const [listState, setListState] = useState({
    data: [],
    isLoading: true,
    total: 0,
    error: null,
    offset: 6,
  });

  const getResources = async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const roleId = user?.roles?.id || null;
      const response = await BraveBupAPI.get('/resources', {
        params: {
          roleId,
        },
      });
      const data = response?.data || [];

      setListState((prevState) => ({
        ...prevState,
        data,
      }));
    } catch (error) {
      setListState((prevState) => ({
        ...prevState,
        error: {
          message:
            'Ocurrio un error inesperado, por favor vuelve a intentarlo.',
        },
        data: [],
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  };
  useEffect(() => {
    getResources();
  }, []);

  const showMore = () => {
    const currentOffset = listState.offset;
    const currentData = listState.data;
    const newOffset =
      currentOffset + 6 > currentData.length
        ? currentData.length
        : currentOffset + 6;
    setListState((prevState) => ({
      ...prevState,
      offset: newOffset,
    }));
  };

  return {
    data: listState.data.slice(0, listState.offset),
    isLoading: listState.isLoading,
    error: listState.error,
    offset: listState.offset,
    total: listState.data.length,
    showMore,
  };
}
